import { all, fork } from 'redux-saga/effects'
import auth from './auth/saga'
import profile from './profile/saga'
import dashboard from './dashboard/saga'
import user from './user/saga'
import licensee from './licensee/saga'
import site from './site/saga'
import locus from './locus/saga'
import mortalitySaga from './mortality/saga'
import satellite from './satellite/saga'
import auditSaga from './audit/saga'
import digitalLogbook from './digitalLogbook/saga'
import layoutSaga from './layout/saga'
import entrySaga from './entry/saga'
import viewSaga from './view/saga'
import dashboardGrowthSaga from './dashboard/growth/saga'
import slaMonitorSaga from './slaMonitor/saga'
import slaEnvironmentsSaga from './slaMonitor/environment/saga'
import seaLiceSaga from './seaLice/saga'
import environmentMonitorSaga from './environmentMonitor/saga'
import logbookSaga from './logbook/saga'
import logbookFormSaga from './logbookForm/saga'
import sisenseSaga from './sisense/saga'
import feedback from './feedback/saga'
import sensor from './sensor/saga'
import monitorsAndAlerts from './monitorsAndAlerts/saga'
import dataBrowserSaga from './dataBrowser/saga'
import locusGroup from './locusGroup/saga'
import files from './common/files/saga'
import exportCSV from './common/exportCSV/saga'
import userGroup from './userGroup/saga'
import siteGroup from './siteGroup/saga'
import applicationSaga from './application/saga'
import licenseeApplication from './licenseeApplication/saga'
import myJobs, { jobsSagaChannels } from './myJobs/saga'
import translationsJobWorkflowSaga from './translations/jobWorkflow/saga'
import translationsJobWorkflowInputSaga from './translations/jobWorkflowInput/saga'
import translationsJobWorkflowTaskSaga from './translations/jobWorkflowTask/saga'
import translationsLogbookEventSaga from './translations/logbookEvent/saga'
import translationsLogbookEventCategorySaga from './translations/logbookEventCategory/saga'
import translationsLogbookFormSaga from './translations/logbookForm/saga'
import translationsMonitoringAlertsSaga from './translations/monitoringAlerts/saga'
import translationsSensorTypeSaga from './translations/sensorType/saga'
import myJobsDataViewer from './myJobsDataViewer/saga'
import jobWorkflows from './jobsWorkflowAdminJob/saga'
import jobTasksAdminSaga from './jobTasksAdmin/saga'
import jobInputsAdminSaga from './jobInputsAdmin/saga'
import jobInputGroupsAdminSaga from './jobInputGroupsAdmin/saga'
import jobInputItemsAdminSaga from './jobInputItemsAdmin/saga'
import projectedSitesManagerSaga from './projectedSitesManager/saga'
import managementUISaga from './managementUI/saga'
import lookupTablesSaga from './lookupTables/saga'
import jobsTriggersSaga from './jobsTriggers/saga'
import featureFlagsSaga from './featureFlags/saga'
import pdfReports from './pdfReports/saga'

export default function* root() {
  yield all([
    fork(auth),
    fork(layoutSaga),
    fork(entrySaga),
    fork(viewSaga),
    fork(profile),
    fork(dashboard),
    fork(user),
    fork(licensee),
    fork(site),
    fork(locus),
    fork(mortalitySaga),
    fork(satellite),
    fork(auditSaga),
    fork(digitalLogbook),
    fork(dashboardGrowthSaga),
    fork(slaMonitorSaga),
    fork(seaLiceSaga),
    fork(environmentMonitorSaga),
    fork(slaEnvironmentsSaga),
    fork(logbookSaga),
    fork(logbookFormSaga),
    fork(sisenseSaga),
    fork(feedback),
    fork(sensor),
    fork(monitorsAndAlerts),
    fork(dataBrowserSaga),
    fork(locusGroup),
    fork(files),
    fork(exportCSV),
    fork(userGroup),
    fork(siteGroup),
    fork(applicationSaga),
    fork(licenseeApplication),
    fork(myJobs),
    fork(translationsJobWorkflowSaga),
    fork(translationsJobWorkflowInputSaga),
    fork(translationsJobWorkflowTaskSaga),
    fork(translationsLogbookEventSaga),
    fork(translationsLogbookEventCategorySaga),
    fork(translationsLogbookFormSaga),
    fork(translationsMonitoringAlertsSaga),
    fork(translationsSensorTypeSaga),
    fork(myJobsDataViewer),
    fork(jobWorkflows),
    fork(jobTasksAdminSaga),
    fork(jobInputsAdminSaga),
    fork(jobInputGroupsAdminSaga),
    fork(jobInputItemsAdminSaga),
    fork(projectedSitesManagerSaga),
    fork(managementUISaga),
    fork(lookupTablesSaga),
    fork(jobsTriggersSaga),
    fork(jobsSagaChannels),
    fork(featureFlagsSaga),
    fork(pdfReports),
  ])
}
